const startButton = document.getElementById("start-btn");
const stopButton = document.getElementById("stop-btn");
const statusEl = document.getElementById("status");
const inputDeviceSelect = document.getElementById("input-device");
const outputDeviceSelect = document.getElementById("output-device");
const refreshDevicesBtn = document.getElementById("refresh-devices-btn");
const debugToggleBtn = document.getElementById("debug-toggle-btn");
const debugPanel = document.getElementById("debug-panel");
const dspBadge = document.getElementById("dsp-badge");
const blocksEl = document.getElementById("dsp-blocks");
const framesEl = document.getElementById("dsp-frames");
const inputChannelsEl = document.getElementById("input-channels");
const rmsInEl = document.getElementById("rms-in");
const rmsOutEl = document.getElementById("rms-out");
const rmsInLeftEl = document.getElementById("rms-in-left");
const rmsInRightEl = document.getElementById("rms-in-right");
const rmsDeltaEl = document.getElementById("rms-delta");
const meterIn = document.getElementById("meter-in");
const meterOut = document.getElementById("meter-out");
const meterDelta = document.getElementById("meter-delta");
const demoDebugPlayingEl = document.getElementById("demo-debug-playing");
const demoDebugAudioTimeEl = document.getElementById("demo-debug-audio-time");
const demoDebugFreezeAtEl = document.getElementById("demo-debug-freeze-at");
const demoDebugFreezeInEl = document.getElementById("demo-debug-freeze-in");
const demoDebugFreezePressedEl = document.getElementById("demo-debug-freeze-pressed");
const demoDebugFreezeLatchedEl = document.getElementById("demo-debug-freeze-latched");
const demoDebugRafEl = document.getElementById("demo-debug-raf");
const demoDebugEventEl = document.getElementById("demo-debug-event");
const demoBtn = document.getElementById("demo-btn");
const demoBtnLabel = document.getElementById("demo-btn-label");
const demoIcon = document.getElementById("demo-icon");

const controls = {
  wet: document.getElementById("wet"),
  dry: document.getElementById("dry"),
  decay: document.getElementById("decay"),
  lowShelfEnabled: document.getElementById("low-shelf"),
  tailRunOnBypass: document.getElementById("tail-run"),
  freezeMuteInput: document.getElementById("freeze-mute"),
};

const bypassStomp = document.getElementById("bypass-stomp");
const freezeStomp = document.getElementById("freeze-stomp");
const bypassLed = document.getElementById("bypass-led");
const freezeLed = document.getElementById("freeze-led");

const valueLabels = {
  wet: document.getElementById("wet-val"),
  dry: document.getElementById("dry-val"),
  decay: document.getElementById("decay-val"),
};

let audioContext = null;
let workletNode = null;
let stream = null;
let sourceNode = null;
let demoSourceNode = null;
let demoRawBytes = null;
let demoAudioBuffer = null;
let demoPlaying = false;
let demoFreezeLatched = false;
let demoFreezeAtAudioTime = null;
let demoAutomationRaf = 0;
let demoAutomationLastEvent = "module-loaded";
let bypassEnabled = false;
let bypassPressed = false;
let freezePressed = false;
let debugVisible = false;
let audioContextPrimed = false;

function setPreferredAudioSession(type) {
  const session = navigator.audioSession;
  if (!session || typeof session !== "object") return;
  try {
    if (session.type !== type) {
      session.type = type;
    }
  } catch {
    // AudioSession is Safari-only and still experimental.
  }
}

function fillDeviceSelect(selectEl, devices, kindLabel) {
  const previous = selectEl.value;
  selectEl.innerHTML = "";

  const defaultOption = document.createElement("option");
  defaultOption.value = "default";
  defaultOption.textContent = `System Default ${kindLabel}`;
  selectEl.appendChild(defaultOption);

  devices.forEach((device, index) => {
    const option = document.createElement("option");
    option.value = device.deviceId;
    option.textContent = device.label || `${kindLabel} ${index + 1}`;
    selectEl.appendChild(option);
  });

  if (previous && [...selectEl.options].some((opt) => opt.value === previous)) {
    selectEl.value = previous;
  } else {
    selectEl.value = "default";
  }
}

async function refreshAudioDevices() {
  if (!navigator.mediaDevices?.enumerateDevices) {
    statusEl.textContent =
      "Device enumeration is not supported in this browser.";
    return;
  }
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const inputs = devices.filter((d) => d.kind === "audioinput");
    const outputs = devices.filter((d) => d.kind === "audiooutput");
    fillDeviceSelect(inputDeviceSelect, inputs, "Input");
    fillDeviceSelect(outputDeviceSelect, outputs, "Output");
  } catch (err) {
    statusEl.textContent = `Failed to list devices: ${err instanceof Error ? err.message : String(err)}`;
  }
}

function clamp01(value) {
  if (value < 0) return 0;
  if (value > 1) return 1;
  return value;
}

function setBadge(active, text) {
  dspBadge.textContent = text;
  dspBadge.classList.toggle("active", active);
}

function formatSeconds(value) {
  if (!Number.isFinite(value)) return "n/a";
  return `${value.toFixed(3)}s`;
}

function updateDemoDebug() {
  if (demoDebugPlayingEl) demoDebugPlayingEl.textContent = String(demoPlaying);
  if (demoDebugAudioTimeEl) {
    const now = audioContext ? audioContext.currentTime : NaN;
    demoDebugAudioTimeEl.textContent = formatSeconds(now);
  }
  if (demoDebugFreezeAtEl) {
    demoDebugFreezeAtEl.textContent = demoFreezeAtAudioTime == null
      ? "n/a"
      : formatSeconds(demoFreezeAtAudioTime);
  }
  if (demoDebugFreezeInEl) {
    if (!audioContext || demoFreezeAtAudioTime == null) {
      demoDebugFreezeInEl.textContent = "n/a";
    } else {
      demoDebugFreezeInEl.textContent = formatSeconds(
        demoFreezeAtAudioTime - audioContext.currentTime,
      );
    }
  }
  if (demoDebugFreezePressedEl) demoDebugFreezePressedEl.textContent = String(freezePressed);
  if (demoDebugFreezeLatchedEl) demoDebugFreezeLatchedEl.textContent = String(demoFreezeLatched);
  if (demoDebugRafEl) demoDebugRafEl.textContent = String(demoAutomationRaf);
  if (demoDebugEventEl) demoDebugEventEl.textContent = demoAutomationLastEvent;
}

window.addEventListener("error", (event) => {
  demoAutomationLastEvent = `window-error:${event.message || "unknown"}`;
  updateDemoDebug();
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason instanceof Error
    ? event.reason.message
    : String(event?.reason ?? "unknown");
  demoAutomationLastEvent = `promise-error:${reason}`;
  updateDemoDebug();
});

function updateStats(stats) {
  blocksEl.textContent = String(stats.blocks ?? 0);
  framesEl.textContent = String(stats.frames ?? 0);
  inputChannelsEl.textContent = String(stats.inputChannels ?? 0);
  const rmsIn = Number(stats.rmsIn ?? 0);
  const rmsOut = Number(stats.rmsOut ?? 0);
  const rmsInLeft = Number(stats.rmsInLeft ?? 0);
  const rmsInRight = Number(stats.rmsInRight ?? 0);
  const rmsDelta = Number(stats.rmsDelta ?? 0);
  rmsInEl.textContent = rmsIn.toFixed(4);
  rmsOutEl.textContent = rmsOut.toFixed(4);
  rmsInLeftEl.textContent = rmsInLeft.toFixed(4);
  rmsInRightEl.textContent = rmsInRight.toFixed(4);
  rmsDeltaEl.textContent = rmsDelta.toFixed(4);
  meterIn.style.width = `${(clamp01(rmsIn) * 100).toFixed(1)}%`;
  meterOut.style.width = `${(clamp01(rmsOut) * 100).toFixed(1)}%`;
  meterDelta.style.width = `${(clamp01(rmsDelta * 2.0) * 100).toFixed(1)}%`;
}

function getControlSnapshot() {
  return {
    wet: Number(controls.wet.value),
    dry: Number(controls.dry.value),
    decay: Number(controls.decay.value),
    // Hardware polarity: XXL up/on disables low-shelf for maximum tail length.
    lowShelfEnabled: !controls.lowShelfEnabled.checked,
    tailRunOnBypass: controls.tailRunOnBypass.checked,
    freezePressed,
    freezeMuteInput: controls.freezeMuteInput.checked,
    bypassEnabled,
    bypassPressed,
  };
}

function updateLabels() {
  valueLabels.wet.textContent = Number(controls.wet.value).toFixed(2);
  valueLabels.dry.textContent = Number(controls.dry.value).toFixed(2);
  valueLabels.decay.textContent = Number(controls.decay.value).toFixed(2);
}

function pushControls() {
  if (!workletNode) return;
  workletNode.port.postMessage({
    type: "controls",
    controls: getControlSnapshot(),
  });
  sync3dPedalVisuals();
}

function refreshPedalVisuals() {
  bypassLed.classList.toggle("on", !bypassEnabled);
  freezeLed.classList.toggle("on", freezePressed);
  bypassStomp.classList.toggle("active", bypassPressed);
  freezeStomp.classList.toggle("active", freezePressed);
  sync3dPedalVisuals();
}

function refreshDebugVisibility() {
  debugPanel.hidden = !debugVisible;
  debugToggleBtn.textContent = debugVisible ? "Hide Debug Info" : "Debug";
  updateDemoDebug();
}

function refreshDemoButton() {
  if (demoPlaying) {
    demoBtnLabel.textContent = "Stop demo";
    demoIcon.innerHTML = "&#9632;";
    demoBtn.classList.add("playing");
  } else {
    demoBtnLabel.textContent = "Listen to a demo";
    demoIcon.innerHTML = "&#9654;";
    demoBtn.classList.remove("playing");
  }
}

function sync3dPedalVisuals() {
  const api = window.familiarPedal3D;
  if (!api || typeof api.setState !== "function") return;
  api.setState(getControlSnapshot());
}

async function unlockAudioContextIfNeeded() {
  setPreferredAudioSession("playback");
  if (!audioContext) {
    audioContext = new AudioContext({ latencyHint: "interactive" });
  }
  if (audioContext.state !== "running") {
    await audioContext.resume();
  }
  if (!audioContextPrimed) {
    // iOS Safari often needs one explicit silent render after resume before
    // WebAudio output becomes reliably audible.
    const primeBuffer = audioContext.createBuffer(1, 1, audioContext.sampleRate);
    const primeSource = audioContext.createBufferSource();
    primeSource.buffer = primeBuffer;
    const primeGain = audioContext.createGain();
    primeGain.gain.value = 0;
    primeSource.connect(primeGain);
    primeGain.connect(audioContext.destination);
    primeSource.start();
    primeSource.stop(audioContext.currentTime + 0.001);
    audioContextPrimed = true;
  }
}

// Shared audio pipeline — created on first use by either demo or live input.
async function ensureAudioReady() {
  await unlockAudioContextIfNeeded();
  if (workletNode) return;

  const outputDeviceId = outputDeviceSelect.value;
  if (outputDeviceId && outputDeviceId !== "default") {
    if (typeof audioContext.setSinkId === "function") {
      try {
        await audioContext.setSinkId(outputDeviceId);
      } catch (err) {
        statusEl.textContent = `Output device selection failed, using default: ${err instanceof Error ? err.message : String(err)}`;
      }
    }
  }

  await audioContext.audioWorklet.addModule("dist/familiar_place_web.js");
  await audioContext.audioWorklet.addModule("worklet.js");

  statusEl.textContent = "Loading DSP engine\u2026";
  const wasmResponse = await fetch("dist/familiar_place_web.wasm", {
    credentials: "same-origin",
  });
  if (!wasmResponse.ok) {
    throw new Error(`Failed to fetch wasm: ${wasmResponse.status}`);
  }
  const wasmBinary = new Uint8Array(await wasmResponse.arrayBuffer());

  workletNode = new AudioWorkletNode(audioContext, "familiar-place-worklet", {
    numberOfInputs: 1,
    numberOfOutputs: 1,
    outputChannelCount: [2],
    processorOptions: { wasmBinary },
  });

  workletNode.port.onmessage = (event) => {
    const message = event.data;
    if (message?.type === "ready") {
      if (message.ok) {
        setBadge(true, "Running");
      } else {
        setBadge(false, "Init failed");
        statusEl.textContent = `WASM init failed: ${message.error ?? "unknown error"}`;
      }
    } else if (message?.type === "stats") {
      if (message.ready) setBadge(true, "Running");
      updateStats(message);
    }
  };

  workletNode.connect(audioContext.destination);
  if (audioContext.state !== "running") {
    await audioContext.resume();
  }
  pushControls();
  refreshPedalVisuals();
}

async function teardownAudio() {
  stopDemoPlayback();
  demoAudioBuffer = null;

  if (sourceNode) {
    sourceNode.disconnect();
    sourceNode = null;
  }
  if (workletNode) {
    workletNode.disconnect();
    workletNode = null;
  }
  if (stream) {
    stream.getTracks().forEach((track) => track.stop());
    stream = null;
  }
  if (audioContext) {
    await audioContext.close();
    audioContext = null;
  }
  audioContextPrimed = false;
  setPreferredAudioSession("auto");

  freezePressed = false;
  bypassEnabled = false;
  refreshPedalVisuals();
  setBadge(false, "Stopped");
  resetStats();
}

function resetStats() {
  updateStats({
    blocks: 0,
    frames: 0,
    inputChannels: 0,
    rmsIn: 0,
    rmsOut: 0,
    rmsInLeft: 0,
    rmsInRight: 0,
    rmsDelta: 0,
  });
}

// ── Live input ────────────────────────────────────────

async function start() {
  if (stream) return;
  statusEl.textContent = "Requesting audio input\u2026";
  setPreferredAudioSession("play-and-record");
  await unlockAudioContextIfNeeded();

  const inputDeviceId = inputDeviceSelect.value;
  const audioConstraints = {
    channelCount: 2,
    echoCancellation: false,
    noiseSuppression: false,
    autoGainControl: false,
  };
  if (inputDeviceId && inputDeviceId !== "default") {
    audioConstraints.deviceId = { exact: inputDeviceId };
  }

  stream = await navigator.mediaDevices.getUserMedia({
    audio: audioConstraints,
  });
  await refreshAudioDevices();
  await ensureAudioReady();

  sourceNode = audioContext.createMediaStreamSource(stream);
  sourceNode.connect(workletNode);

  statusEl.textContent = "Running.";
  startButton.disabled = true;
  stopButton.disabled = false;
}

async function stop() {
  if (!audioContext) return;
  await teardownAudio();
  statusEl.textContent = "Stopped.";
  startButton.disabled = false;
  stopButton.disabled = true;
  setPreferredAudioSession("playback");
}

// ── Demo playback ─────────────────────────────────────

async function loadDemoAudio() {
  if (demoAudioBuffer) return demoAudioBuffer;

  if (!demoRawBytes) {
    const resp = await fetch("dry_input.mp3");
    if (!resp.ok) throw new Error("Demo audio file not found");
    demoRawBytes = await resp.arrayBuffer();
  }

  demoAudioBuffer = await audioContext.decodeAudioData(demoRawBytes.slice(0));
  return demoAudioBuffer;
}

function stopDemoAutomation() {
  demoAutomationLastEvent = "stop-automation";
  demoFreezeAtAudioTime = null;
  if (demoAutomationRaf) {
    cancelAnimationFrame(demoAutomationRaf);
    demoAutomationRaf = 0;
  }
  updateDemoDebug();
}

function runDemoAutomation() {
  demoAutomationLastEvent = "raf-tick";
  if (
    demoPlaying &&
    !demoFreezeLatched &&
    demoFreezeAtAudioTime != null &&
    audioContext &&
    audioContext.currentTime >= demoFreezeAtAudioTime
  ) {
    demoAutomationLastEvent = "trigger-freeze";
    setFreezePressed(true);
    demoFreezeLatched = true;
    demoFreezeAtAudioTime = null;
    statusEl.textContent = "Playing demo… (freeze latched)";
  }

  if (demoPlaying || demoFreezeAtAudioTime != null) {
    demoAutomationRaf = requestAnimationFrame(runDemoAutomation);
  } else {
    demoAutomationLastEvent = "raf-idle";
    demoAutomationRaf = 0;
  }
  updateDemoDebug();
}

function startDemoAutomation() {
  if (!audioContext) return;
  demoAutomationLastEvent = "start-automation";
  demoFreezeAtAudioTime = audioContext.currentTime + 125;
  if (!demoAutomationRaf) {
    demoAutomationRaf = requestAnimationFrame(runDemoAutomation);
  }
  updateDemoDebug();
}

function stopDemoPlayback() {
  demoAutomationLastEvent = "stop-demo";
  stopDemoAutomation();
  if (demoSourceNode) {
    try {
      demoSourceNode.stop();
    } catch {}
    demoSourceNode.disconnect();
    demoSourceNode = null;
  }
  demoPlaying = false;
  // Keep demo-triggered freeze latched after playback stops.
  refreshDemoButton();
  updateDemoDebug();
}

async function toggleDemo() {
  demoAutomationLastEvent = "toggle-demo-enter";
  updateDemoDebug();
  if (demoPlaying) {
    stopDemoPlayback();
    if (!stream) statusEl.textContent = "Idle.";
    return;
  }

  statusEl.textContent = "Loading demo\u2026";
  demoAutomationLastEvent = "toggle-demo-unlock";
  updateDemoDebug();
  await unlockAudioContextIfNeeded();
  demoAutomationLastEvent = "toggle-demo-ready";
  updateDemoDebug();
  await ensureAudioReady();
  setPreferredAudioSession("playback");
  demoAutomationLastEvent = "toggle-demo-load-buffer";
  updateDemoDebug();
  const buffer = await loadDemoAudio();

  demoSourceNode = audioContext.createBufferSource();
  demoSourceNode.buffer = buffer;
  demoSourceNode.connect(workletNode);
  demoSourceNode.onended = () => {
    demoAutomationLastEvent = "demo-ended";
    stopDemoAutomation();
    demoPlaying = false;
    // Keep demo-triggered freeze latched after playback ends.
    demoSourceNode = null;
    refreshDemoButton();
    if (!stream) statusEl.textContent = "Idle.";
    updateDemoDebug();
  };
  demoSourceNode.start();
  demoFreezeLatched = false;
  startDemoAutomation();
  demoPlaying = true;
  demoAutomationLastEvent = "demo-started";
  refreshDemoButton();
  statusEl.textContent = "Playing demo\u2026";
  updateDemoDebug();
}

// ── Event listeners ───────────────────────────────────

function setFreezePressed(value) {
  demoAutomationLastEvent = `set-freeze-${value ? "on" : "off"}`;
  freezePressed = value;
  refreshPedalVisuals();
  pushControls();
  updateDemoDebug();
}

function toggleBypassEnabled() {
  bypassEnabled = !bypassEnabled;
  refreshPedalVisuals();
  pushControls();
}

function setBypassPressed(value) {
  bypassPressed = value;
  refreshPedalVisuals();
}

bypassStomp.addEventListener("pointerdown", (event) => {
  event.preventDefault();
  setBypassPressed(true);
  toggleBypassEnabled();
});
bypassStomp.addEventListener("pointerup", (event) => {
  event.preventDefault();
  setBypassPressed(false);
});
bypassStomp.addEventListener("pointercancel", () => setBypassPressed(false));
bypassStomp.addEventListener("pointerleave", () => setBypassPressed(false));

freezeStomp.addEventListener("pointerdown", (event) => {
  event.preventDefault();
  setFreezePressed(true);
});
freezeStomp.addEventListener("pointerup", (event) => {
  event.preventDefault();
  setFreezePressed(false);
});
freezeStomp.addEventListener("pointercancel", () => setFreezePressed(false));
freezeStomp.addEventListener("pointerleave", () => setFreezePressed(false));

debugToggleBtn.addEventListener("click", () => {
  debugVisible = !debugVisible;
  refreshDebugVisibility();
});
refreshDevicesBtn.addEventListener("click", () => {
  refreshAudioDevices();
});

if (navigator.mediaDevices?.addEventListener) {
  navigator.mediaDevices.addEventListener("devicechange", () => {
    refreshAudioDevices();
  });
}

Object.values(controls).forEach((element) => {
  element.addEventListener("input", () => {
    updateLabels();
    pushControls();
  });
  element.addEventListener("change", pushControls);
});

startButton.addEventListener("click", () => {
  start().catch((err) => {
    statusEl.textContent = `Start failed: ${err instanceof Error ? err.message : String(err)}`;
  });
});
stopButton.addEventListener("click", () => {
  stop().catch((err) => {
    statusEl.textContent = `Stop failed: ${err instanceof Error ? err.message : String(err)}`;
  });
});
demoBtn.addEventListener("click", () => {
  demoAutomationLastEvent = "demo-btn-click";
  updateDemoDebug();
  toggleDemo().catch((err) => {
    demoAutomationLastEvent = `demo-error:${err instanceof Error ? err.message : String(err)}`;
    updateDemoDebug();
    statusEl.textContent = `Demo failed: ${err instanceof Error ? err.message : String(err)}`;
  });
});

// Pre-unlock audio on initial touch/pointer so Safari keeps output audible on
// the subsequent async demo startup path.
const preunlockAudioFromGesture = () => {
  unlockAudioContextIfNeeded().catch(() => {});
};
demoBtn.addEventListener("pointerdown", preunlockAudioFromGesture, { passive: true });
demoBtn.addEventListener("touchstart", preunlockAudioFromGesture, { passive: true });

function stopAudioForFocusLoss(reason) {
  if (!audioContext) return;
  demoAutomationLastEvent = reason;
  updateDemoDebug();
  stop().catch(() => {});
}

const stopOnFocusLoss = window.matchMedia?.("(pointer: coarse)")?.matches ?? false;
if (stopOnFocusLoss) {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      stopAudioForFocusLoss("page-hidden");
    }
  });

  window.addEventListener("pagehide", () => {
    stopAudioForFocusLoss("page-hide");
  });

  window.addEventListener("blur", () => {
    stopAudioForFocusLoss("window-blur");
  });
}

// ── Init ──────────────────────────────────────────────

updateLabels();
refreshPedalVisuals();
refreshDebugVisibility();
refreshDemoButton();
refreshAudioDevices();
setBadge(false, "Not running");
resetStats();
updateDemoDebug();

// ── Knob interaction ──────────────────────────────────

document.querySelectorAll(".knob-assembly").forEach((assembly) => {
  const knobBody = assembly.querySelector(".knob-body");
  const input = assembly.querySelector('input[type="range"]');
  if (!knobBody || !input) return;

  function updateRotation() {
    const norm =
      (Number(input.value) - Number(input.min)) /
      (Number(input.max) - Number(input.min));
    knobBody.style.transform = `rotate(${-135 - norm * 270}deg)`;
  }

  let dragging = false;
  let startY = 0;
  let startVal = 0;

  knobBody.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    dragging = true;
    startY = e.clientY;
    startVal = Number(input.value);
    knobBody.setPointerCapture(e.pointerId);
  });

  knobBody.addEventListener("pointermove", (e) => {
    if (!dragging) return;
    const dy = startY - e.clientY;
    const range = Number(input.max) - Number(input.min);
    let val = startVal + (dy / 200) * range;
    val = Math.max(Number(input.min), Math.min(Number(input.max), val));
    input.value = val;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    updateRotation();
  });

  knobBody.addEventListener("pointerup", () => {
    dragging = false;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  knobBody.addEventListener("pointercancel", () => {
    dragging = false;
  });

  knobBody.addEventListener(
    "wheel",
    (e) => {
      e.preventDefault();
      const range = Number(input.max) - Number(input.min);
      const step = range / 100;
      let val = Number(input.value) + (e.deltaY < 0 ? step : -step);
      val = Math.max(Number(input.min), Math.min(Number(input.max), val));
      input.value = val;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      updateRotation();
    },
    { passive: false },
  );

  input.addEventListener("input", updateRotation);
  updateRotation();
});

window.addEventListener("fp-3d-control", (event) => {
  const detail = event?.detail;
  if (!detail || typeof detail !== "object") return;

  if (detail.type === "knob" && typeof detail.key === "string") {
    const target = controls[detail.key];
    if (!target || typeof detail.value !== "number") return;
    const min = Number(target.min);
    const max = Number(target.max);
    const next = Math.max(min, Math.min(max, detail.value));
    target.value = String(next);
    target.dispatchEvent(new Event("input", { bubbles: true }));
    target.dispatchEvent(new Event("change", { bubbles: true }));
    return;
  }

  if (detail.type === "toggle" && typeof detail.key === "string") {
    const target = controls[detail.key];
    if (!target || target.type !== "checkbox") return;
    target.checked = !target.checked;
    target.dispatchEvent(new Event("input", { bubbles: true }));
    target.dispatchEvent(new Event("change", { bubbles: true }));
    return;
  }

  if (detail.type === "bypass" && typeof detail.pressed === "boolean") {
    if (detail.pressed) {
      toggleBypassEnabled();
    }
    setBypassPressed(detail.pressed);
    return;
  }

  if (detail.type === "freeze" && typeof detail.pressed === "boolean") {
    setFreezePressed(detail.pressed);
  }
});

sync3dPedalVisuals();
